"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldName = void 0;
var FieldName;
(function (FieldName) {
    // general fields
    FieldName["Id"] = "id";
    FieldName["Name"] = "name";
    // mostly relevant for "User" node (represent fb user)
    FieldName["FirstName"] = "first_name";
    FieldName["LastName"] = "last_name";
    FieldName["MiddleName"] = "middle_name";
    FieldName["NameFormat"] = "name_format";
    FieldName["ShortName"] = "short_name";
    FieldName["Picture"] = "picture";
    FieldName["Email"] = "email";
    FieldName["Accounts"] = "accounts";
    FieldName["AccessToken"] = "access_token";
    FieldName["Tasks"] = "tasks";
    // mostly relevant for "Page" (represent fb page) & "IgUser" (represent ig account) nodes
    FieldName["IgId"] = "ig_id";
    FieldName["Username"] = "username";
    FieldName["ProfilePictureUrl"] = "profile_picture_url";
    FieldName["Biography"] = "biography";
    FieldName["Website"] = "website";
    FieldName["InstagramBusinessAccount"] = "instagram_business_account";
    FieldName["InstagramAccounts"] = "instagram_accounts";
    FieldName["BusinessDiscovery"] = "business_discovery";
    FieldName["Insights"] = "insights";
    FieldName["MediaCount"] = "media_count";
    FieldName["FollowersCount"] = "followers_count";
    FieldName["FollowsCount"] = "follows_count";
    FieldName["Media"] = "media";
    // media
    FieldName["Caption"] = "caption";
    FieldName["CommentsCount"] = "comments_count";
    FieldName["LikeCount"] = "like_count";
    FieldName["MediaUrl"] = "media_url";
    FieldName["Permalink"] = "permalink";
    FieldName["Timestamp"] = "timestamp";
    FieldName["MediaType"] = "media_type";
    FieldName["MediaProductType"] = "media_product_type";
})(FieldName = exports.FieldName || (exports.FieldName = {}));
//# sourceMappingURL=fieldNames.enum.js.map